// extracted by mini-css-extract-plugin
export default {"container":"sync_container__ersnS","header":"sync_header__d+a7w","headerIcon":"sync_headerIcon__Yf1K5","headerTitle":"sync_headerTitle__WRLnN"};